import { useTranslation } from "react-i18next";
import { BoldText, CruiseSubHeader, CruiseWrapper, Description, ListItem, StyledList, } from "../styled";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import { LINKS } from "../../../config/links";

const Boats = () => {
    const { t } = useTranslation("boats");

    const rentalItems = t("sections.rental.items", { returnObjects: true });
    const whyItems = t("sections.why.items", { returnObjects: true });
    const infoItems = t("sections.info.items", { returnObjects: true });
    const locationsItems = t("sections.locations.items", { returnObjects: true });

    const renderList = (items) => (
        <StyledList>
            {items.map((item, idx) => (
                <ListItem key={idx}>
                    <BoldText>{item.label} </BoldText>
                    {item.text}
                </ListItem>
            ))}
        </StyledList>
    );

    return (
        <CruiseWrapper id={LINKS.sections.boatsDescription}>
            <StaggeredContainer>
                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.rental.title")}</CruiseSubHeader>
                </StaggeredItem>
                <StaggeredItem>
                    <Description>{t("sections.rental.intro")}</Description>
                </StaggeredItem>
                <StaggeredItem>{renderList(rentalItems)}</StaggeredItem>

                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.why.title")}</CruiseSubHeader>
                </StaggeredItem>
                <StaggeredItem>{renderList(whyItems)}</StaggeredItem>

                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.info.title")}</CruiseSubHeader>
                </StaggeredItem>
                <StaggeredItem>
                    <Description>{t("sections.info.intro")}</Description>
                </StaggeredItem>
                <StaggeredItem>{renderList(infoItems)}</StaggeredItem>

                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.locations.title")}</CruiseSubHeader>
                </StaggeredItem>
                <StaggeredItem>
                    <Description>{t("sections.locations.intro")}</Description>
                </StaggeredItem>
                <StaggeredItem>{renderList(locationsItems)}</StaggeredItem>
            </StaggeredContainer>
        </CruiseWrapper>
    );
};

export default Boats;